import { useState } from "react";
import moment from "moment";
import "moment/locale/ru";
import cn from "classnames";

import { ModuleModal } from "../ModuleModal/ModuleModal.jsx";

import styles from "./ModuleItem.module.css";

export const ModuleItem = ({ module, student, plag }) => {
  const [showModal, setShowModal] = useState(false);
  const mainContent = () => {
    if (student) {
      return (
        <div
          className={cn(
            styles.moduleItemTitle,
            "d-flex flex-wrap justify-content-between"
          )}
        >
          <div className="d-flex flex-column justify-content-end mr-2 mr-sm-0">
            <span className={styles.moduleItemPlaceholder}>Название:</span>
            <h1 className={styles.moduleItemTitle}>{module.course.name}</h1>
          </div>
          <div className="d-flex flex-column justify-content-end mt-2 mt-sm-0">
            {module.date ? (
              <>
                <span className={styles.moduleItemPlaceholder}>
                  Дата окончания:
                </span>
                <h2 className="m-0">
                  {moment(module.date).format("D MMM YYYY")}
                </h2>
              </>
            ) : (
              <h2 className={cn(styles.moduleItemPlaceholder, "m-0")}>
                Модуль в процессе изучения
              </h2>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className={cn(styles.moduleItemTitle, "row")}>
          <div className="col-sm-6 col-md-3 my-auto my-md-0">
            <span className={styles.moduleItemPlaceholder}>Название:</span>
            <h1 className={styles.moduleItemTitle}>{module.course.name}</h1>
          </div>
          <div className="col-sm-6 col-md-3 my-auto my-md-0">
            <span className={styles.moduleItemPlaceholder}>
              Прохождение открытого урока:
            </span>
            <div className="d-block">
              {module.opened ? (
                <i
                  style={{ color: "#5dd001" }}
                  className="fa fa-check"
                  aria-hidden="true"
                ></i>
              ) : (
                <i
                  style={{ color: "#fe5f48" }}
                  className="fa fa-times"
                  aria-hidden="true"
                ></i>
              )}
            </div>
          </div>
          <div className="col-sm-6 col-md-3 my-auto my-md-0">
            <span className={styles.moduleItemPlaceholder}>
              Зачет на знание модуля:
            </span>
            <div className="d-block">
              {module.credit ? (
                <i
                  style={{ color: "#5dd001" }}
                  className="fa fa-check"
                  aria-hidden="true"
                ></i>
              ) : (
                <i
                  style={{ color: "#fe5f48" }}
                  className="fa fa-times"
                  aria-hidden="true"
                ></i>
              )}
            </div>
          </div>
          <div className="col-sm-6 col-md-3 my-auto my-md-0">
            {module.date ? (
              <>
                <span className={styles.moduleItemPlaceholder}>
                  Дата окончания:
                </span>
                <h2 className="m-0">
                  {moment(module.date).format("D MMM YYYY")}
                </h2>
              </>
            ) : (
              <h2 className={cn(styles.moduleItemPlaceholder, "m-0")}>
                Модуль в процессе изучения
              </h2>
            )}
          </div>
        </div>
      );
    }
  };
  return (
    <>
      <div
        className={styles.wrapper}
        style={{ cursor: student ? "pointer" : "" }}
        onClick={() => {
          if (student) setShowModal(true);
        }}
      >
        <div
          className={styles.topLine}
          style={{
            backgroundColor: plag ? "#bababa" : module.course.module.color,
          }}
        ></div>
        <div
          className={styles.body}
          style={{
            borderColor: plag ? "#bababa" : module.course.module.color,
            backgroundColor: plag
              ? "#f2f2f2"
              : module.course.module.color + "33",
          }}
        >
          {plag ? (
            <h1 className="text-center m-0">
              Образовательные модули отсутствуют!
            </h1>
          ) : (
            mainContent()
          )}
        </div>
      </div>
      {student && (
        <ModuleModal
          module={module}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};
